'use client';

import { Button } from '@nextui-org/react';
import { useEffect } from 'react';

interface ErrorProps {
  error: Error;
  reset: () => void;
}
export default function Error({ error, reset }: ErrorProps) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="grid h-screen text-center place-items-center">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold">Something went wrong!</h2>
        <Button
          onPress={
            // Attempt to recover by trying to re-render the segment
            () => reset()
          }
        >
          Try again
        </Button>
      </div>
    </div>
  );
}
